import React from "react";
import type { TenantInfo } from "../../helpers/tenants";

interface TenantSelectorProps {
  tenants: TenantInfo[];
  value: string;
  onChange: (tenantId: string) => void;
  className?: string;
  labelClassName?: string;
  selectClassName?: string;
  id?: string;
}

const DEFAULT_LABEL_CLASS = "block text-sm font-medium text-gray-700 mb-2";
const DEFAULT_SELECT_CLASS =
  "block w-full px-3 py-2.5 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all duration-200";

/**
 * ADR-021 tenant picker (backoffice standard, Tailwind).
 *
 * Renders nothing when the operator has a single grant — there is nothing to
 * choose. Pair with useTenantSelection(); on change, refetch the page's
 * tenant-scoped data.
 */
const TenantSelector: React.FC<TenantSelectorProps> = ({
  tenants,
  value,
  onChange,
  className,
  labelClassName = DEFAULT_LABEL_CLASS,
  selectClassName = DEFAULT_SELECT_CLASS,
  id = "tenant-selector",
}) => {
  if (tenants.length <= 1) return null;

  return (
    <div className={className}>
      <label htmlFor={id} className={labelClassName}>
        Tenant
      </label>
      <select
        id={id}
        className={selectClassName}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {tenants.map((t) => (
          <option key={t.id} value={t.id}>
            {t.name || t.id}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TenantSelector;
